angular.module('lf.common')

.directive('scopeToggle', function () {
  return {
    scope: true,
    restrict: 'A',
    link: function (scope, el, attrs) {
      el.on('click', function () {
        scope[attrs.scopeToggle] = !scope[attrs.scopeToggle];
        scope.$apply();
      });
    }
  }
});
